/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { map } from 'lodash';
import { Header, Text } from '@blend/enterprise-components';

import { Pricing } from 'blb-types/pricing';
import { ColumnConfig, FormShape } from '../types';
import { inputFormatters } from '@blend/shared-react';

const styles = StyleSheet.create({
  rightAlignItem: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
  },
});

const paymentMilestoneMap: Record<Pricing.PaymentMilestone, string> = {
  AtClosing: 'At Closing',
  BeforeClosing: 'Before Closing',
};

const formatColumnValue = (columnName: string, columnValue: any): any => {
  switch (columnName) {
    case 'amount':
      return inputFormatters.MONEY_CENTS.formatWithDollarSignAndCents(columnValue);
    case 'paymentMilestone':
      const milestone = columnValue as Pricing.PaymentMilestone;
      return paymentMilestoneMap[milestone] || milestone;
    default:
      return columnValue;
  }
};

export const generateLedgerSubsectionRow = (
  columnConfigs: ColumnConfig[],
  subsectionKey: Pricing.LoanEstimateSectionTypes,
  rowIdx: number,
  formValues: FormShape,
): JSX.Element[] => {
  return map(columnConfigs, (columnConfig, idx) => {
    const columnValue = formValues[subsectionKey]![rowIdx][columnConfig.name];

    const formSectionComponent = (
      <Text colorName="NIGHT_80" fontSize="md" key={rowIdx}>
        {formatColumnValue(columnConfig.name, columnValue)}
      </Text>
    );
    // last col on table is right aligned
    return idx === columnConfigs.length - 1 ? (
      <div className={css(styles.rightAlignItem)}>{formSectionComponent}</div>
    ) : (
      formSectionComponent
    );
  });
};

export const generateLedgerSubsectionTableHeader = (columnConfigs: ColumnConfig[]): JSX.Element[] => {
  return map(columnConfigs, (columnConfig, idx) => {
    const headerComponent = (
      <Header colorName="NIGHT_90" ellipsis fontWeight="BOLD" size={6}>
        {columnConfig.headerDisplay}
      </Header>
    );
    // last col on table is right aligned
    return idx === columnConfigs.length - 1 ? (
      <div className={css(styles.rightAlignItem)}>{headerComponent}</div>
    ) : (
      headerComponent
    );
  });
};
